import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import tokens from './tokens.json';

interface SectionErrorProps {
  title?: string;
  description?: string;
  cta?: React.ReactNode;
}

function SectionError({ title, description, cta }: SectionErrorProps) {
  return (
    <Box height="100%" display="flex" flexDirection="column">
      <Typography aria-label={title ?? tokens['GENERAL_ERROR']} variant="body1" component="p">
        {title ?? tokens['GENERAL_ERROR']}
      </Typography>
      {description ? (
        <Typography variant="body1" role="alert">
          {description}
        </Typography>
      ) : null}
      {cta ? cta : null}
    </Box>
  );
}

export default SectionError;
